import { render } from "./MMB.vue?vue&type=template&id=b5de8176"
import script from "./MMB.vue?vue&type=script&lang=js"
export * from "./MMB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__